import { SidebarOpenerLink } from 'shared/components/Sidebar/Sidebar.styles'
import { ProfilePageTab } from 'shared/pages/ProfilePage/ProfilePage'

import { useUser } from '../../helpers/useUser'
import { EmailField, FullNameField } from '../Fields'
import { UserSidebar } from '../Sidebar/UserSidebar'

interface UserLinkProps {
  user: { id: string; first_name?: string; last_name?: string }
  children?: React.ReactNode
  sidebarOpener?: React.ReactNode
  showEmail?: boolean
  initialTab?: ProfilePageTab
}

export function UserLink({
  user: partialUser,
  children,
  sidebarOpener,
  showEmail,
  initialTab,
}: UserLinkProps) {
  const { user } = useUser(partialUser.id ?? '', {
    enabled: Boolean(partialUser.id && (!partialUser?.first_name || showEmail) && !sidebarOpener),
  })

  if (sidebarOpener) {
    return (
      <UserSidebar userId={partialUser.id} initialTab={initialTab}>
        {sidebarOpener}
      </UserSidebar>
    )
  }

  if (user || partialUser.first_name) {
    return (
      <UserSidebar userId={partialUser.id} initialTab={initialTab}>
        <SidebarOpenerLink>
          {showEmail ? <EmailField record={user} /> : <FullNameField record={user || partialUser} />}
        </SidebarOpenerLink>
      </UserSidebar>
    )
  }

  return <>{children}</>
}
